import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-create-note-dialog',
  template: `
  <h1 mat-dialog-title>{{ isNewNote ? 'New Note':'Edit Note'}}</h1>

  <div mat-dialog-content class="content">
    <!-- Adiciona o elemento img para mostrar a imagem selecionada -->
    <div *ngIf="imageSrc" class="flex align-items-center justify-content-center  pl-3 pr-3"  style="position: relative; margin-bottom: 20px;"  >
      <img [src]="imageSrc" style="max-height: 150px; max-width: 80%; ">
      <!-- Botão de exclusão -->
      <button class="p-button p-button-rounded p-button-danger p-button-text" style="position: absolute; right: 0; top: 0;" (click)="removeImage()">
        <i class="pi pi-times"></i>
      </button>
    </div>
    <mat-form-field class="pl-3 pr-3" style="position: relative;">
    <mat-label>Note description</mat-label>
      <textarea
        matInput
        matTextareaAutosize
            cdkTextareaAutosize
            cdkAutosizeMinRows="7"
            cdkAutosizeMaxRows="18"
        [(ngModel)]="text"
        cdkFocusInitial>
      ></textarea>
      <button *ngIf="text" mat-icon-button (click)="text=''" style="position: absolute; right: -16px; top: 0;">
       <mat-icon>close</mat-icon>
      </button>

    </mat-form-field>
    <div class="text-right -mt-4">

      <button mat-icon-button  (click)="fileInput.click()">
          <mat-icon>add_photo_alternate</mat-icon>
      </button>

      <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="uploadFile" accept="image/png, image/jpeg">
    </div>

    <div *ngIf="textHasMultiplesLines() && isNewNote" class="-mt-5 pl-1 pr-6">

     <mat-checkbox  class="example-margin"
                  [checked]="multipleNotes"
                  (change)="enableDisableMultipleNotes($event.checked)">
         {{checkboxInfo()}}
      </mat-checkbox>
    </div>

   </div>

  <mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button [disabled]="!enableSabeButton()" [mat-dialog-close]="{textData: text, multipleNotes: multipleNotes, textArray: textArray, imageFile: imageFile, imageSrc: imageSrc}">{{ isNewNote ? 'Save':'Update'}}</button>
  </mat-dialog-actions>
  `,
  styleUrls: ['./dialog.scss']
})
export class CreateNoteDialogComponent implements OnInit {

  text: string = '';
  textArray: string[] = null;
  multipleNotes: boolean = false;
  imageFile: File | null = null;
  imageSrc: string | ArrayBuffer | null = null; // Para armazenar o URL da imagem
  @ViewChild('fileInput') fileInput: ElementRef; // Adiciona esta linha

  isNewNote = true;

  constructor(
    public dialogRef: MatDialogRef<CreateNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {text: string, multiplesNotes: boolean, textArray: string[], imageSrc: string | ArrayBuffer | null}
  ) {
    if (data) {
      this.isNewNote = false;
      this.text = data.text;
      this.imageSrc = data.imageSrc;
    }
  }

  checkboxInfo() {
    return "Create a new note for each line of text " + (this.imageFile ? "(the image will not be saved)":"");
  }

  textHasMultiplesLines(): boolean {
    const textHasMultiplesLines = this.text.includes("\n")

    if (this.multipleNotes) {
      this.textArray = this.text.split("\n");
    } else {
      this.textArray = null;
    }

    return textHasMultiplesLines;
  }

  enableDisableMultipleNotes(enable: boolean) {
    this.multipleNotes = enable;

    if (this.multipleNotes) {
      this.textArray = this.text.split("\n");
    } else {
      this.textArray = null;
    }
  }

  enableSabeButton(): boolean {
    return this.text.length > 0 || this.imageFile !== null;
  }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onFileSelected(event: any): void {
    if (event.target.files && event.target.files.length > 0) {
      this.imageFile = event.target.files[0];

      // Cria um URL de objeto para o arquivo de imagem e atualiza imageSrc para exibir a imagem
      const reader = new FileReader();
      reader.onload = (e) => this.imageSrc = e.target.result;
      reader.readAsDataURL(this.imageFile);
    }
  }

  removeImage(): void {
    // Libera o URL de objeto, se aplicável
    if (typeof this.imageSrc === 'string') {
      URL.revokeObjectURL(this.imageSrc);
    }
    this.imageSrc = null;
    this.imageFile = null;
    // Resetar o valor do input file para permitir a seleção do mesmo arquivo novamente, se necessário
    if (this.fileInput) {
      this.fileInput.nativeElement.value = "";
    }
  }

}

